import React from "react";
import FormField from "../components/FormField";
import DateField from "../components/DateField";

const CONDITION_OPTIONS = [
  { value: "healthy", label: "سالم و بدون نقص" },
  { value: "minor_issue", label: "دارای ایراد جزئی" },
  { value: "needs_repair", label: "نیازمند تعمیر" },
];

export default function Step5ConditionInfo({ data, onChange }) {
  const handleDeliveryTimeChange = (e) => {
    let value = e.target.value.replace(/[^۰-۹0-9:]/g, "").replace(/:+/g, ":");
    const digits = value.replace(/:/g, "");
    if (digits.length <= 2) value = digits;
    else value = digits.slice(0, 2) + ":" + digits.slice(2, 4);
    onChange({ target: { name: "deliveryTime", value } });
  };

  return (
    <div>
      <h2 className="text-lg font-bold text-navy">وضعیت تحویل خودرو</h2>
      <p className="mt-1 text-sm text-gray-500">
        تاریخ، ساعت و وضعیت خودرو در لحظه تحویل را ثبت کنید.
      </p>
      <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2">
        <DateField
          label="تاریخ تحویل"
          name="deliveryDate"
          value={data.deliveryDate}
          onChange={onChange}
          required
        />
        <FormField
          label="ساعت تحویل"
          name="deliveryTime"
          type="text"
          value={data.deliveryTime}
          onChange={handleDeliveryTimeChange}
          placeholder="مثلاً ۱۴:۳۰"
          required
        />
        <FormField
          label="وضعیت خودرو"
          name="vehicleCondition"
          type="select"
          value={data.vehicleCondition}
          onChange={onChange}
          options={CONDITION_OPTIONS}
          required
        />
        <FormField
          label="کیلومتر خودرو"
          name="vehicleMileage"
          type="number"
          value={data.vehicleMileage}
          onChange={onChange}
          placeholder="مثلاً ۸۵۰۰۰"
          unit="کیلومتر"
          required
        />
      </div>
    </div>
  );
}
